import React from 'react';
import { useApp } from '../hooks/AppContext';
import { getCurrentPayMonth, getSimulatorMonths } from '../utils/helpers';

export default function Header({ page, setPage, tab, setTab }) {
  const { user, activeMonth, isSimulating, logout, switchMonth, isAdmin, isHO } = useApp();

  const navItems = [
    { id: 'home', label: '🏠 Home', show: true },
    { id: 'report', label: '📊 Reports', show: isAdmin || isHO },
    { id: 'manage', label: '⚙ Data', show: isAdmin },
    { id: 'cutoff', label: '⏰ Cut-off', show: isAdmin },
    { id: 'users', label: '👤 Users', show: isAdmin },
    { id: 'backup', label: '💾 Backup', show: isAdmin || isHO, danger: true },
  ];

  const handleNav = (id) => {
    if (id === 'home') { setPage('home'); setTab('dashboard'); }
    else if (id === 'manage') { setPage('home'); setTab('admin'); }
    else { setPage(id); }
  };

  const isActive = (id) => {
    if (id === 'home') return page === 'home' && tab === 'dashboard';
    if (id === 'manage') return page === 'home' && tab === 'admin';
    return page === id;
  };

  const roleLabel = isAdmin ? 'Admin' : isHO ? 'HO Manager' : user?.cbsbrcd;
  const months = getSimulatorMonths();
  const current = getCurrentPayMonth();

  return (
    <>
      {/* Month simulator bar */}
      {(isAdmin || isHO) && (
        <div className="persist-bar">
          <div className="pb-left">
            <span className="pb-label">🧪 Active Month:</span>
            <select
              className="sim-select"
              value={isSimulating ? activeMonth : ''}
              onChange={e => switchMonth(e.target.value)}
            >
              <option value="">📅 {current} (Live)</option>
              {months.map(m => (
                <option key={m.key} value={m.key}>
                  {m.label}{m.key === current ? ' ◄ current' : ''}
                </option>
              ))}
            </select>
            <span className={`sim-badge ${isSimulating ? 'sim-on' : 'sim-off'}`}>
              {isSimulating ? `⚡ SIMULATING` : '● LIVE'}
            </span>
          </div>
        </div>
      )}

      {/* Main header */}
      <div className="header">
        <div className="header-left">
          <span className="header-icon">🏪</span>
          <span className="header-brand">Godown Rent</span>
          <div className="hnav">
            {navItems.filter(n => n.show).map(n => (
              <button
                key={n.id}
                className={`hnav-btn ${n.danger ? 'danger' : ''} ${isActive(n.id) ? 'on' : ''}`}
                onClick={() => handleNav(n.id)}
              >
                {n.label}
              </button>
            ))}
          </div>
        </div>
        <div className="header-right">
          <span className="header-role">{roleLabel}</span>
          <span className="header-name">{user?.name}</span>
          <button className="btn btn-o btn-sm btn-logout" onClick={logout}>Logout</button>
        </div>
      </div>
    </>
  );
}
